import { IQuizResultData } from '../../../api/QuizApiSdk';

export class VtoQuiz {
    public productBenefitTypes: string;
    public productIds: string;
    public crosssellNode: number;
    public extraCareNode: number;
    public skinDiagramNode: number;
    public skincareRegimenNode: number;
    public skinTipsNode: number;

    public static fromJson(data: IQuizResultData): VtoQuiz {
        const vtoQuiz = new VtoQuiz();
        vtoQuiz.productBenefitTypes = data.product_benefit_type;
        vtoQuiz.productIds = data.product_id;
        vtoQuiz.crosssellNode = Number(data.crosssell_content_1);
        vtoQuiz.extraCareNode = Number(data.extra_care);
        vtoQuiz.skinDiagramNode = Number(data.skin_diagrams);
        vtoQuiz.skincareRegimenNode = Number(data.skincare_regimen);
        vtoQuiz.skinTipsNode = Number(data.tips);

        return vtoQuiz;
    }
}
